function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
window.addEventListener('load', function () {
  var heroBanner = document.querySelector('.shopify-section.hero-banner');
  if (heroBanner !== null) {
    var buttons = heroBanner.querySelectorAll('.hero-cta');
    var nav = document.getElementById('sticky-nav');
    if (buttons !== null) {
      var _iterator = _createForOfIteratorHelper(buttons),
        _step;
      try {
        var _loop = function _loop() {
          var button = _step.value;
          var embedContainer = document.getElementById(button.dataset.id);
          button.addEventListener('click', function () {
            if (embedContainer !== null) {
              embedContainer.scrollIntoView({
                block: 'center',
                behavior: 'smooth'
              });
              var scrolledY = window.scrollY;
              if (scrolledY) {
                window.scroll(0, scrolledY - nav.getBoundingClientRect().height);
              }
            }
          });
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }
  function scrollIntoViewOffset(destination, offset) {
    window.scrollTo({
      behavior: 'smooth',
      top: destination.getBoundingClientRect().top - document.body.getBoundingClientRect().top - offset
    });
  }
  var links = document.querySelectorAll('[href^="#"]');
  if (links.length > 0) {
    var _iterator2 = _createForOfIteratorHelper(links),
      _step2;
    try {
      var _loop2 = function _loop2() {
        var link = _step2.value;
        if (link.href !== undefined) {
          var newUrl = new URL(link.href);
          var urlHash = newUrl.hash;
          if (urlHash) {
            link.addEventListener('click', function (event) {
              event.preventDefault();
              var link = urlHash.replace('#', '');
              var clickDestination = document.getElementById(link);
              if (clickDestination === null) {
                return;
              }
              var navContainer = document.querySelector('header');
              var navHeight = window.getComputedStyle(navContainer).getPropertyValue('--header-sticky-height').replace(/[^\d]/g, '');
              scrollIntoViewOffset(clickDestination, navHeight);
            });
          }
        }
      };
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        _loop2();
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
});